import { createContext } from 'react';
const debug = false;
export const AlertManagementContextDefault = {
    loaded: false,
    fetchingSeedCustomer: false,
    seedCustomer: undefined,
    contextCustomer: undefined,
    contextUser: undefined,
    isAdmin: undefined,
    contextUserIsAdmin: false,
    visibleGroups: [],
    fetchingGlobalRulesets: false,
    globalRulesets: [],
    fetchingLocalRulesets: false,
    localRulesets: [],
};
const initialAlertManagementState = [AlertManagementContextDefault, () => { }];
export const AlertManagementContextReducer = (state, action) => {
    debug && console.log('Alert Management context update:', action);
    return { ...state, ...action };
};
export const AlertManagementContext = createContext(initialAlertManagementState);
